var exports = {
  "v5": "dialogBody__r9D7b7",
  "eH": "formGroup__U59ien",
  "wL": "charCount__hmb9d8",
  "JN": "warningCaption__UCPaV_",
  "fN": "readOnlyInput__tvOxrw",
  "_H": "pagesCheckbox__-iJU87",
};

module.exports = exports;
